import BodySimpleModalV3 from '../modal/BodySimpleModalV3'
import classes from './RadioField.module.css'

const RadioButton = ({item, checked, changeHandler, name, isDisable, justDisplay, redFlag, clickHandler, isBlocked}) => {

    return <BodySimpleModalV3 message={isBlocked?.message} disabled={!isBlocked || (isBlocked.value != item.value)}>
        <div  className={`${classes.radio_filed_item} ${isDisable ? classes.is_disabled : ''} ${(isBlocked && isBlocked.value == item.value) ? classes.is_blocked : ''} ${(redFlag == item.value) ? classes.red_flag : ''}`} style={{display: (justDisplay && !checked) ? 'none' : ''}} onClick={clickHandler}>
            <input type="radio" id={item.label + name} name={name} value={item.value} checked={checked} onChange={changeHandler} disabled={isDisable || (isBlocked && isBlocked.value == item.value)}/>
            <label htmlFor={item.label + name}>{item.label}</label>
        </div>
    </BodySimpleModalV3>
}

export default RadioButton